export default "__VITE_ASSET__Kl136P5g__"